module.exports = __webpack_public_path__ + "static/media/organisations-mob-icon.c08dce1b.svg";